module.exports = __webpack_public_path__ + "img/ak.bed4d19c.png";